import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListStatusCell } from './emsp-bo-rfid-badge-order-list-status.cell';
import { EmspBoRfidBadgeOrderListStatusHeader } from './emsp-bo-rfid-badge-order-list-status.header';

export const EmspBoRfidBadgeOrderListStatusColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['status']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListStatusHeader,
  cell: EmspBoRfidBadgeOrderListStatusCell,
};
